import React from "react";
import AIPlayground from "../components/AIPlayground/AIPlayground";

/**
 * AIPlaygroundPage component that serves as a page wrapper for the AIPlayground component
 * This provides a dedicated page for the AI Playground functionality
 */
export const AIPlaygroundPage = () => <AIPlayground />;
